var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{attrs:{"size":"small","disabled":_vm.disabled,"fetch-suggestions":_vm.querySearchAsync,"placeholder":"请输入关键词","clearable":""},on:{"select":_vm.handleChange,"blur":_vm.handleBlur,"clear":_vm.handleBlur},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e6c9a7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/UserSelect.vue
// module id = 1193
// module chunks = 0